import { LwApiPM } from "@techniaorg/liteweb-api";

export const waitForIFrameAndModel = (
  element: HTMLIFrameElement
): Promise<LwApiPM> => {
  return new Promise<LwApiPM>((resolve, reject) => {
    if (!element.contentWindow) {
      reject("No contentWindow");
      return;
    }
    const LwAPI = new LwApiPM(element.contentWindow);
    let started = false;
    // Once the viewer is reachable, wait for the model-ready event.
    const start = () => {
      if (started) return;
      started = true;
      let listenerId = -1;
      LwAPI.registerOnReady(() => {
        LwAPI.unregisterOnReady(listenerId);
        resolve(LwAPI);
      }).then((id) => {
        listenerId = id;
      });
    };
    // Normal case: the iframe fires "load" after we attach this listener.
    element.addEventListener("load", start);
    // Race case: the iframe already fired "load" before this code ran (e.g.
    // served from cache), so the listener above will never fire. Probe with a
    // harmless command — if the viewer is already up it responds and we start
    // waiting for the model. If it isn't up yet the probe is lost, but the
    // "load" listener will start us instead.
    LwAPI.getHelpUrl()
      .then(start)
      .catch(() => {
        /* not ready yet — the load listener will start us */
      });
  });
};

export const waitForIFrame = (element: HTMLIFrameElement): Promise<LwApiPM> => {
  return new Promise<LwApiPM>((resolve, reject) => {
    if (!element.contentWindow) {
      reject("No contentWindow");
      return;
    }
    const LwAPI = new LwApiPM(element.contentWindow);
    let settled = false;
    const finish = () => {
      if (!settled) {
        settled = true;
        resolve(LwAPI);
      }
    };
    // Normal case: the iframe fires "load" after we attach this listener.
    element.addEventListener("load", finish);
    // Race case: the iframe already fired "load" before this code ran (e.g.
    // served from cache), so the listener above will never fire. Probe with a
    // harmless command — if the viewer is already up it responds and we resolve.
    // If it isn't up yet the probe is lost, but the "load" listener will catch it.
    LwAPI.getHelpUrl()
      .then(finish)
      .catch(() => {
        /* not ready yet — the load listener will resolve us */
      });
  });
};

export const modelPathOnServer = "";
